// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { bellCheck16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-bell-check': IconBellCheck;
    }
}

/**
 * The icon component for the 'bellCheck' icon
 */
export class IconBellCheck extends IconSvg {
    public constructor() {
        super(bellCheck16X16);
    }
}

registerIconSvg('icon-bell-check', IconBellCheck);
export const iconBellCheckTag = 'nimble-icon-bell-check';
